<template>
  <v-flex>
    <Loader v-show="!isApiLoaded"/>
    <v-layout wrap class="mx-2">
      <v-flex xs12 sm12 md12 lg12 xl12
        :style="{ background: dashboardGradient }"
        data-qa="amendtaxsavings-flex-3dl6ek">
        <v-container class="pa-6 pl-12" data-qa="amendtaxsavings-container-dd82j">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="amendtaxsavings-flex-xs31s5">
            <v-row no-gutters data-qa="amendtaxsavings-row-mgina">
              <v-layout row wrap class="pb-2" data-qa="amendtaxsavings-layout-4782a">
                <inline-svg
                  class="mt-2"
                  :src="getNavigationIcon()"
                  width="50"
                  height="50"
                  aria-label="Navigation Icon"
                />
                <font
                  class="display-1 font-weight-thin white--text pt-4 pl-2"
                  >{{ this.$t('accountDetails.taxAccountsLabel') }}</font
                >
              </v-layout>
            </v-row>
            <v-row class="pl-4" data-qa="amendtaxsavings-row-vbbhnm">
              <v-layout wrap data-qa="amendtaxsavings-layout-879ypp">
                <v-flex lg9 xl9 data-qa="amendtaxsavings-flex-sqygqc">
                  <v-layout row wrap data-qa="amendtaxsavings-layout-7p9ml9">
                    <v-flex xs12 sm6 md6 lg4 xl3 class="px-1" data-qa="amendtaxsavings-flex-wrxnwh">
                      <font class="subheading font-weight-medium white--text">{{
                        $t("accountDetails.accountNumber")
                      }}</font>
                      <br>
                      <font class="text-h5 font-weight-bold white--text">{{
                        form.accountNumber
                      }}</font>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg5 xl3 class="px-1" data-qa="amendtaxsavings-flex-c6kuwa">
                      <font class="subheading font-weight-medium white--text">{{
                        $t("taxAccountDetails.depositAmount")
                      }}</font>
                      <br>
                      <font class="text-h5 font-weight-bold white--text">{{
                        $formatter.currency.format(form.balance, form.currency)
                      }}</font>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>

    <v-container>
      <v-form
        ref="form"
        v-model="model.isFormValid"
      >
        <v-card class="pa-4" elevation="1" rounded="lg">
          <v-card-title class="font-weight-bold">
            {{ $t("amendTaxAccount.whatToAmendLabel") }}
          </v-card-title>
          <v-card-text>
            <v-autocomplete
              v-model="selectedMaturityInstruction"
              :items="miOptions"
              :color="primaryColor"
              :label="$t('amendTaxAccount.selectMaturityInstruction')"
              :rules="[rules.required]"
              @change="updateMIDetails"
              filled
              :menu-props="{ transition: 'scale-transition' }"
              clearable
              class="input-filled-bg"
              data-qa="selected-maturity-instruction"
            />
            <v-expand-transition>
              <v-card
                v-if="['amendSwitchToNewFixedRateCashIsa', 'amendSwitchToOtherCashIsa'].includes(selectedMaturityInstruction)"
                flat
              >
                <span class="body-1 font-weight-bold pb-2">
                  {{ $t("amendTaxAccount.pleaseSelectYourPreferredCashIsaProduct") }}
                </span>
                <v-autocomplete
                  v-model="selectedSubProduct"
                  :label="$t('amendTaxAccount.selectCashIsaSubProducts')"
                  :rules="[rules.required]"
                  :items="selectedMaturityInstruction === 'amendSwitchToNewFixedRateCashIsa' ? otherFixedRateProducts : otherCashIsaProducts"
                  item-text="productDescription"
                  item-value="productId"
                  :menu-props="{ transition: 'scale-transition' }"
                  filled
                  clearable
                  :color="primaryColor"
                  class="input-filled-bg"
                  data-qa="selected-sub-product"
                />
              </v-card>
              <v-card
                v-if="selectedMaturityInstruction === 'amendOptionCreditEntire'"
                flat
                key="amendOptionCreditEntire"
              >
                <AmendTaxSavingsSelectPayaway
                  v-model="selectedPayAwayAcc"
                  :accountId="form.accountNumber"
                  :currency="form.currency"
                  :sameBankAccounts="api.ownAccounts"
                  :otherBankAccounts="api.otherAccounts"
                  class="input-filled-bg"
                  data-qa="selected-payaway-acc"
                />
              </v-card>
              <v-card
                key="reinvestToNewFixedRateCashIsa"
                flat
                v-if="selectedMaturityInstruction === 'reinvestToNewFixedRateCashIsa'"
              >
                <span class="body-1 font-weight-bold pb-2">
                  {{ $t("amendTaxAccount.amtTransferToPayaway") }}
                </span>
                <v-radio-group
                  class="mt-0"
                  v-model="model.radio.selectedRadio"
                  mandatory
                  row
                >
                  <v-radio
                    value="amount"
                    :color="primaryColor"
                  >
                    <template v-slot:label>
                      <NumberInput
                        v-model="model.radio.rolloverAmount"
                        :label="$t('common.amount')"
                        filled
                        class="input-filled-bg"
                        :isRequired="isAmountSelected"
                        :prefix="$formatter.currency.getCurrencySymbol(form.currency)"
                        :rules="[
                          v => !isAmountSelected || rules.rolloverGreaterThanZero('Rollover Amount')(v)
                        ]"
                        @focus="model.radio.rolloverPercent = ''"
                        data-qa="rollover-amount"
                      />
                    </template>
                  </v-radio>
                  <v-radio
                    value="percent"
                    :color="primaryColor"
                  >
                    <template v-slot:label>
                      <NumberInput
                        v-model="model.radio.rolloverPercent"
                        :label="$t('common.percent')"
                        filled
                        :isRequired="isPercentSelected"
                        prefix="%"
                        :rules="[
                          v => !isPercentSelected || rules.rolloverGreaterThanZero('Rollover Percentage')(v),
                          v => !isPercentSelected || rules.rolloverExclusiveMaxLimit('Rollover Percentage', 100)(v)
                        ]"
                        class="input-filled-bg"
                        @focus="model.radio.rolloverAmount = ''"
                        data-qa="rollover-percent"
                      />
                    </template>
                  </v-radio>
                </v-radio-group>
                <span class="body-1 font-weight-bold pb-2">
                  {{ $t("amendTaxAccount.pleaseSelectYourPreferredCashIsaProduct") }}
                </span>
                <v-autocomplete
                  v-model="selectedSubProduct"
                  :label="$t('amendTaxAccount.selectCashIsaSubProducts')"
                  :rules="[rules.required]"
                  :items="otherFixedRateProducts"
                  item-text="productDescription"
                  item-value="productId"
                  :menu-props="{ transition: 'scale-transition' }"
                  filled
                  clearable
                  class="input-filled-bg"
                  :color="primaryColor"
                  data-qa="selected-sub-product"
                />
                <AmendTaxSavingsSelectPayaway
                  v-model="selectedPayAwayAcc"
                  :accountId="form.accountNumber"
                  :currency="form.currency"
                  :sameBankAccounts="api.ownAccounts"
                  :otherBankAccounts="api.otherAccounts"
                  data-qa="selected-payaway-acc"
                />
              </v-card>
            </v-expand-transition>
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="goToSavingsAccounts"
              :color="primaryColor"
              outlined
              class="text-capitalize py-2 px-4"
              v-text="$t('common.back')"
              data-qa="goto-savings-account-btn"
            />
            <v-btn
              @click="onNext"
              :color="primaryColor"
              :disabled="!model.isFormValid"
              :dark="model.isFormValid"
              class="text-capitalize py-2 px-4"
              v-text="$t('common.next')"
              data-qa="next-btn"
            />
          </v-card-actions>
        </v-card>
      </v-form>
    </v-container>

    <OtpHandler
      v-if="showOTPScreen"
      @otp-cancelled="showOTPScreen = false"
      @otp-success="amendTaxSavingsAcc"
    />

    <ConfirmTaxSavings
      v-if="confirmFormData.showConfimModal"
      :config="confirmFormData"
    />
  </v-flex>
</template>

<script>
import commonService from '@/service/commonService.js'
import Loader from '../../../components/common/Loader.vue'
import preload from '@/util/preload'
import AmendTaxSavingsSelectPayaway from './AmendTaxSavingsSelectPayaway.vue'
import NumberInput from '../../../components/common/NumberInput.vue'

export default {
  name: 'AmendTaxSavings',
  data () {
    return {
      form: {
        accountNumber: '',
        balance: 0,
        currency: ''
      },
      model: {
        radio: {
          rolloverAmount: '',
          rolloverPercent: '',
          selectedRadio: null
        },
        isFormValid: false
      },
      api: {
        accountDetails: {},
        ownAccounts: [],
        otherAccounts: [],
        taxsavingsDetails: {},
        subProducts: []
      },
      confirmFormData: {
        showConfimModal: false
      },
      isApiLoaded: false,
      showOTPScreen: false,
      selectedPayAwayAcc: null,
      defaultMaturityInstruction: '',
      selectedMaturityInstruction: '',
      selectedSubProduct: null
    }
  },
  components: {
    Loader,
    OtpHandler: () => import('@/components/common/OtpHandler.vue'),
    ConfirmTaxSavings: () => import('@/views/accounts/accountDetails/ConfirmTaxSavings.vue'),
    AmendTaxSavingsSelectPayaway,
    NumberInput
  },
  async created () {
    if (this.$route.params?.accountType && this.$route.params?.accountNumber) {
      this.accountType = this.$route.params.accountType
      this.form.accountNumber = this.$route.params.accountNumber
      this.form.balance = this.$route.params.balance
      this.form.currency = this.$route.params.currency;

      [
        this.api.accountDetails,
        this.api.ownAccounts,
        this.api.otherAccounts,
        this.api.taxsavingsDetails,
        this.api.subProducts
      ] = await Promise.all([
        this.getAccountDetails(this.form.accountNumber),
        this.getSameBanks(),
        this.getBeneficiaries(),
        this.getTaxsavingsDetails(this.form.accountNumber),
        this.getSubProducts(this.form.currency)
      ])
      this.isApiLoaded = true

      this.selectedMaturityInstruction = this.getDefaultMI()
      this.defaultMaturityInstruction = this.selectedMaturityInstruction
      this.setDefaultMIDetails()
    } else {
      this.$router.push({ path: '/home' })
    }
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('Savings_1')
    },
    async getAccountDetails (accountNumber) {
      return (await commonService.getAccountDetails(accountNumber)) || {}
    },
    async getTaxsavingsDetails (accountNumber) {
      return (await commonService.getTaxsavingsDetails(accountNumber)) || {}
    },
    getDefaultMI () {
      const { fixedRateMaturityInstructions: mi, fixedRateTaxSavingsDetails: sd } = this.api.taxsavingsDetails
      if (mi === 'FIXED-RATE-TAX-SAVINGS' && sd.principalPayAwayAccounts?.[0]) {
        return 'reinvestToNewFixedRateCashIsa'
      }
      const mapMI = {
        'NO-INSTRUCTIONS': 'amendNoInstruction',
        'FIXED-RATE-TAX-SAVINGS': mi === 'FIXED-RATE-TAX-SAVINGS' && sd.principalPayAwayAccounts?.[0]
          ? 'reinvestToNewFixedRateCashIsa'
          : 'amendSwitchToNewFixedRateCashIsa',
        'TAX-SAVINGS': 'amendSwitchToOtherCashIsa',
        'PAYAWAY-BOTH': 'amendOptionCreditEntire',
        'TRANSFER-OUT': 'amendTransferOut'
      }
      return mapMI[mi]
    },
    setDefaultMIDetails () {
      const td = this.api.taxsavingsDetails
      const setDefaultPayAwayAcc = () => {
        const { otherBankAccount, payawayAccountId } = td.fixedRateTaxSavingsDetails.principalPayAwayAccounts[0]
        this.selectedPayAwayAcc = { otherBankAccount, payawayAccountId }
      }

      if (['amendSwitchToNewFixedRateCashIsa', 'amendSwitchToOtherCashIsa'].includes(this.selectedMaturityInstruction)) {
        this.selectedSubProduct = td.switchOverProductID
      }
      if (this.selectedMaturityInstruction === 'amendOptionCreditEntire') {
        setDefaultPayAwayAcc()
      }
      if (this.selectedMaturityInstruction === 'reinvestToNewFixedRateCashIsa') {
        setDefaultPayAwayAcc()
        this.selectedSubProduct = td.switchOverProductID

        const { rolloverAmount, rolloverPercent } = td.fixedRateTaxSavingsDetails
        const { radio } = this.model
        radio.rolloverAmount = rolloverAmount.amount || ''
        radio.rolloverPercent = rolloverPercent || ''
        radio.selectedRadio = radio.rolloverAmount ? 'amount' : radio.rolloverPercent ? 'percent' : null
      }
    },
    async getSameBanks () {
      const response = await preload.getAccountsWithBalance(JSON.parse(sessionStorage.getItem('username')))
      return response?.causes ? [] : response
    },
    async getBeneficiaries () {
      const response = await commonService.getBeneficiaries(JSON.parse(sessionStorage.getItem('username')))
      return response?.causes ? [] : response.items
    },
    onNext () {
      const enableOTP = this.$appSettings.defaultConfigurations.enableOTPForAmendTaxSavings
      if (enableOTP) {
        this.showOTPScreen = true
      } else {
        this.amendTaxSavingsAcc()
      }
    },
    getMaturityInstructionBody () {
      const payload = {
        fixedRateMaturityInstructions: this.fixedRateMaturityInstructions
      }
      if (this.selectedMaturityInstruction === 'amendSwitchToNewFixedRateCashIsa') {
        payload.switchOverProductID = this.selectedSubProduct
        payload.fixedRateTaxSavingsDetails = {
          rolloverPercent: 100
        }
      }
      if (this.selectedMaturityInstruction === 'amendSwitchToOtherCashIsa') {
        payload.switchOverProductID = this.selectedSubProduct
      }
      if (this.selectedMaturityInstruction === 'amendOptionCreditEntire') {
        payload.fixedRateTaxSavingsDetails = {
          principalPayAwayAccounts: this.principalPayAwayAccounts
        }
      }
      if (this.selectedMaturityInstruction === 'reinvestToNewFixedRateCashIsa') {
        payload.switchOverProductID = this.selectedSubProduct
        payload.fixedRateTaxSavingsDetails = {
          principalPayAwayAccounts: this.principalPayAwayAccounts
        }
        if (this.isAmountSelected) {
          payload.fixedRateTaxSavingsDetails.rolloverAmount = {
            amount: this.model.radio.rolloverAmount,
            currency: this.form.currency
          }
        }
        if (this.isPercentSelected) {
          payload.fixedRateTaxSavingsDetails.rolloverPercent = this.model.radio.rolloverPercent
        }
      }
      return payload
    },
    async amendTaxSavingsAcc () {
      this.showOTPScreen = false
      const body = this.getMaturityInstructionBody()
      const response = await commonService.amendTaxSavingsAccount(this.form.accountNumber, body)
      if (response && !response.causes) {
        response.accountId && this.getFormData(response)
      } else {
        this.$store.dispatch('appStore/setAppData', {
          message: {
            title: 'Error',
            width: 400,
            persistent: true,
            saveButton: this.$t('common.okay'),
            content: this.$t('amendTaxAccount.amendErrorMessage'),
            type: 'error',
            component: 'dob-modal'
          }
        })
      }
    },
    getFormData (respData) {
      this.confirmFormData = { showConfimModal: false }
      if (respData) {
        this.confirmFormData.action = 'amend'
        this.confirmFormData.showConfimModal = true
        this.confirmFormData.accountDetails = this.api.accountDetails
      }
    },
    goToSavingsAccounts () {
      const item = this.api.accountDetails
      this.$router.replace({ name: 'AccountDetails', params: { product: item, balance: item.subscriptionAmountUsed, accountId: item.accountId, accountType: item.accountType, currency: item.currency } })
    },
    async getSubProducts (currency) {
      const resp = await commonService.getCASAProductsList({ currencyType: currency, isAccTypeApplicable: 'S' })
      return !resp ? [] : resp.items
    },
    updateMIDetails () {
      this.selectedSubProduct = null
      this.selectedPayAwayAcc = null
      this.model.radio.rolloverAmount = ''
      this.model.radio.rolloverPercent = ''
      this.model.radio.selectedRadio = null
      if (this.defaultMaturityInstruction === this.selectedMaturityInstruction) {
        this.setDefaultMIDetails()
      }
    }
  },
  computed: {
    rules () {
      return {
        required: v => Boolean(v) || this.$t('errors.common.required'),
        rolloverGreaterThanZero: field => v => v > 0 || this.$t('amendTaxAccount.error.rolloverGreaterThanZero', { field }),
        rolloverExclusiveMaxLimit: (field, exclusiveMaxLimit) => v => v < exclusiveMaxLimit || this.$t('amendTaxAccount.error.rolloverExclusiveMaxLimit', { field, exclusiveMaxLimit })
      }
    },
    isAmountSelected () {
      return this.model?.radio?.selectedRadio === 'amount'
    },
    isPercentSelected () {
      return this.model?.radio?.selectedRadio === 'percent'
    },
    fixedRateMaturityInstructions () {
      const map = {
        amendNoInstruction: 'NO-INSTRUCTIONS',
        amendSwitchToNewFixedRateCashIsa: 'FIXED-RATE-TAX-SAVINGS',
        amendSwitchToOtherCashIsa: 'TAX-SAVINGS',
        amendOptionCreditEntire: 'PAYAWAY-BOTH',
        reinvestToNewFixedRateCashIsa: 'FIXED-RATE-TAX-SAVINGS',
        amendTransferOut: 'TRANSFER-OUT'
      }
      return map[this.selectedMaturityInstruction] || null
    },
    miOptions () {
      const instructions = [
        'amendNoInstruction',
        'amendSwitchToNewFixedRateCashIsa',
        'amendSwitchToOtherCashIsa',
        'amendOptionCreditEntire',
        'reinvestToNewFixedRateCashIsa',
        'amendTransferOut'
      ]
      return instructions.map(instruction => ({
        value: instruction,
        text: this.$t(`amendTaxAccount.maturityInstruction.${instruction}`)
      }))
    },
    otherFixedRateProducts () {
      return this.api.subProducts.filter(i => i.productType === 'TXFR' && i.productId !== this.api.accountDetails.productIdentifier)
    },
    otherCashIsaProducts () {
      return this.api.subProducts.filter(i => ['TXNA', 'TXEA'].includes(i.productType) && i.productId !== this.api.accountDetails.productIdentifier)
    },
    principalPayAwayAccounts () {
      return [
        {
          otherBankAccount: this.selectedPayAwayAcc.otherBankAccount,
          payawayAccountId: this.selectedPayAwayAcc.payawayAccountId,
          percentage: 100.00
        }
      ]
    }
  }
}
</script>
